<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            userAddData() {return this.$store.getters.ROLE_ADD_DATA},
            permissions() {return this.$store.getters.CONST_PERMISSIONS},
        },
        methods: {
            async changeName(event) {
                this.$store.commit('ROLE_ADD_UPDATE',{
                    fieldName: 'name', 
                    fieldValue: event.target.value,
                });
                this.errorText = await this.$store.dispatch('CHECK_ROLE_ADD');
            },
            async changePermission(event) {
                const target = event.target;
                this.$store.commit('ROLE_ADD_UPDATE',{
                    fieldName: target.value, 
                    fieldValue: target.checked,
                });
                this.errorText = await this.$store.dispatch('CHECK_ROLE_ADD');
            }
        }
    }
</script>


<template>
    <div>
        <label>Name:</label>
        <input 
            @change="changeName"
            :value="userAddData['name']"
            type="text"
            class="mt_5 mb_10"
        >
    </div>
    <div>
        <label>Permissions:</label>
        <ul>
            <li
                v-for="(permissionValue, permissionIndex) in permissions" :key="permissionIndex"
            >
                <label>
                    <input 
                        @change="changePermission"
                        :checked="userAddData[permissionValue['id']]"
                        type="checkbox"
                        :value="permissionValue['id']"
                    >
                    {{ permissionValue['name'] }}
                </label>
            </li>
        </ul>
        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>


<style scoped>
    div {
        display: flex;
        flex-direction: column;
        color: #ffffff;
    }
    input[type='text'] {
        border-radius: 5px;
        border: var(--border);
        padding: 5px;
    }
    ul {
        column-count: 2;
        column-width: 50%;

        max-width: 100%;

        list-style-type: none;

        margin: 0px;
        margin-top: 5px;
        padding: 0px;
    }
</style>